import React, { useEffect, useState } from "react";
import { ROUTES } from "../../commons/constants/routes/routes";

export default function Map({ points, searchCenter }) {
  const { kakao } = window;
  const [map, setMap] = useState(null);
  const [initialCenter, setInitialCenter] = useState(null);

  useEffect(() => {
    const container = document.getElementById("map");
    const options = {
      center: new kakao.maps.LatLng(33.450701, 126.570667),
      level: 8,
    };
    const mapInstance = new kakao.maps.Map(container, options);
    mapInstance.addOverlayMapTypeId(kakao.maps.MapTypeId.SKYVIEW);
    setMap(mapInstance);
    setInitialCenter({ lat: 33.450701, lng: 126.570667 });
  }, []);

  useEffect(() => {
    if (map && points.length > 0) {
      const bounds = new kakao.maps.LatLngBounds();
      const markers = [];

      points.forEach((point) => {
        const xy = point.xy;
        const [lngX, latY] = xy.split(",").map(Number);

        if (lngX && latY) {
          const marker = new kakao.maps.Marker({
            position: new kakao.maps.LatLng(latY, lngX),
          });

          markers.push(marker);
          marker.info = point;
          marker.setMap(map);
          bounds.extend(new kakao.maps.LatLng(latY, lngX));

          const infowindow = new kakao.maps.InfoWindow({
            content: getInfoWindowContents(point.groups),
          });

          kakao.maps.event.addListener(
            marker,
            "click",
            makeOverListener(map, marker, infowindow)
          );
        }
      });

      const clusterer = new kakao.maps.MarkerClusterer({
        map: map,
        averageCenter: true,
        minLevel: 8,
      });
      clusterer.addMarkers(markers);
      map.setBounds(bounds);
    }
  }, [map, points]);

  useEffect(() => {
    if (map && searchCenter) {
      moveToCenter(searchCenter);
    }
  }, [map, searchCenter]);

  const moveToCenter = ({ lng, lat }) => {
    if (map && lng && lat) {
      const moveLatLon = new kakao.maps.LatLng(lat, lng);
      map.setCenter(moveLatLon);
      map.setLevel(5);
    }
  };

  let selectedInfoWindow = "";
  // 인포윈도우를 표시하는 클로저를 만드는 함수입니다
  function makeOverListener(map, marker, infowindow) {
    return function () {
      if (selectedInfoWindow != "" && selectedInfoWindow !== infowindow) {
        selectedInfoWindow.close();
      }
      selectedInfoWindow = infowindow;
      infowindow.open(map, marker);
    };
  }

  // 인포윈도우를 닫는 클로저를 만드는 함수입니다
  function makeOutListener(infowindow) {
    return function () {
      infowindow.close();
    };
  }

  function getInfoWindowContents(groups) {
    let contents =
      '<div class="map-modal" style="background-color: transparent;">';
    contents += `<div class="h-stack group">
                        <div class="w70 size15"><strong>주&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;소</strong></div>
                        <div class="size14"><b>${groups[0].address}</b></div>
                    </div>`;
    groups.some((v, idx) => {
      if (groups.length === 1) {
        contents += `<br/>
                            <div class="h-stack group">
                                <div class="w80 size15"><strong>프로젝트</strong></div>
                                <div class="size14"><a href="#" onclick="saveProjectInfo('${v.name}', '${v.id}')" >${
          v.name
        }</div>
                            </div>`;
      } else {
        contents += `<br/>
                            <div class="h-stack group">
                                <div class="w80 size15"><strong>프로젝트${
                                  idx + 1
                                }</strong></div>
                                <div class="size14">${v.name}</div>
                            </div>`;
      }
    });
    contents += "</div>";
    return contents;
  }

  return <div id="map" style={{ width: "100%", height: "600px" }}></div>;
}

// 전역으로 함수 등록
window.saveProjectInfo = function (name, id) {
  localStorage.setItem("projectTitle", name);
  setTimeout(() => {
    window.location.href = ROUTES.PLANT_LIST(id).MAIN;
  }, 100);
};
